<template>
  <c-container fluid class="d-flex content-center min-vh-100 login-container c-app c-dark-theme">
    <logo-long-boss />
    <c-row>
      <c-col>
        <c-card-group>
          <c-card class="p-4 login-form">
            <c-card-body>
              <c-form @submit.prevent="resetPassword">
                <template v-if="passwordResetSuccess">
                  <p class="h4 mb-4">Nice work, Boss :)</p>
                  <p>
                    If a KoalaBoss account exists for
                    <strong>{{ form.email }}</strong>, we'll send an email with a link to reset your password.
                  </p>
                </template>

                <template v-else>
                  <p class="h4 mb-4">Forgot your password?</p>
                  <p>Enter your email address so we can send you a link to reset your password.</p>
                  <c-alert show color="warning" v-if="error" close-button class="mt-4">
                    {{ error }}
                  </c-alert>
                  <div class="login-fields">
                    <c-input
                      class="email-address"
                      type="email"
                      :lazy="true"
                      :value.sync="$v.form.email.$model"
                      :is-valid="checkIfValid('email')"
                      placeholder="Email address"
                      autocomplete="email"
                      invalid-feedback="Please enter a valid email address"
                      :disabled="isSendingPasswordReset"
                      autofocus
                    >
                      <template #prepend-content>
                        <c-icon name="cil-envelope-closed" />
                      </template>
                    </c-input>
                  </div>
                  <c-row class="mt-4">
                    <c-col col="12" class="text-center">
                      <CButton type="submit" class="px-4 w-100 btn-primary">
                        <CSpinner v-if="isSendingPasswordReset" color="success" size="sm" />
                        <span v-else>Send reset link</span>
                      </CButton>
                    </c-col>
                  </c-row>
                </template>

                <c-row class="mt-4">
                  <c-col col="12" class="text-center">
                    <router-link class="link" to="/login">Back to Login</router-link>
                  </c-col>
                </c-row>
              </c-form>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
    <c-row class="mt-3">
      <c-col col="12" class="text-center">
        <span class="small">
          Don't have an account?
          <a class="px-0 link" href="https://koalaboss.com" target="_blank">Get one</a>
        </span>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { buildEndpoint } from '@/libs/buildEndPoint';
import LogoLongBoss from '@/views/components/images/long-boss';

export default {
  name: 'ForgotPassword',
  components: {
    LogoLongBoss,
  },
  mixins: [validationMixin],
  data() {
    return {
      error: null,
      isSendingPasswordReset: false,
      passwordResetSuccess: false,
      form: {
        email: null,
      },
    };
  },
  computed: {
    isValid() {
      return !this.$v.form.$invalid;
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    resetPassword() {
      this.$v.$touch();
      if (this.isValid) {
        this.isSendingPasswordReset = true;
        setTimeout(() => {
          const data = {
            username: this.form.email,
          };
          this.$http
            .post(buildEndpoint('password/reset/generate'), data)
            .then((response) => {
              this.passwordResetSuccess = true;
            })
            .catch(() => {
              this.error = 'There was a problem resetting the password. Please try again.';
            });
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss"></style>
